const ACCESS_TOKEN_KEY = 'auth.access-token'

/** Treat token as expired this many ms before `exp` (clock skew). */
const EXPIRY_SKEW_MS = 30_000

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

const isJwtShape = (token: string): boolean => token.split('.').length === 3

const getJwtExpMs = (token: string): number | null => {
  try {
    const payload = token.split('.')[1]
    if (!payload) {
      return null
    }
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=')
    const claims = JSON.parse(atob(padded)) as { exp?: unknown }
    return typeof claims.exp === 'number' ? claims.exp * 1000 : null
  } catch {
    return null
  }
}

/** True when an Entra access token (JWT) is stored. Does not check expiry. */
const hasEntraAccessToken = (): boolean => {
  const token = getAccessToken()
  return Boolean(token && isJwtShape(token))
}

/** True when Entra JWT exists and is not expired. */
export const hasValidEntraAccessToken = (): boolean => {
  const token = getAccessToken()
  if (!token || !isJwtShape(token)) {
    return false
  }

  const expMs = getJwtExpMs(token)
  if (expMs === null) {
    return false
  }

  return Date.now() < expMs - EXPIRY_SKEW_MS
}

/** JWT present but past `exp` (or unreadable). */
export const hasExpiredEntraAccessToken = (): boolean => {
  return hasEntraAccessToken() && !hasValidEntraAccessToken()
}
